var map = {
	"./components/admin/AllowedRooms.vue": 4045,
	"./components/admin/AllowedUsers.vue": 7926,
	"./components/admin/Notifications.vue": 7187,
	"./components/admin/Period.vue": 8873,
	"./components/admin/Reservations.vue": 613,
	"./components/layout/HomeTab.vue": 15,
	"./components/layout/Modal.vue": 3604,
	"./components/layout/Navbar.vue": 9327,
	"./components/svg/AccountFullIcon.vue": 3723,
	"./components/svg/AccountIcon.vue": 3031,
	"./components/svg/CloseIcon.vue": 6423,
	"./components/user/DormComponent.vue": 5431,
	"./components/user/FloorComponent.vue": 1217,
	"./components/user/NotificationComponent.vue": 2502,
	"./components/user/PopupComponent.vue": 1183,
	"./components/user/RoomComponent.vue": 7734,
	"./components/user/UpcomingPeriods.vue": 3755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6273;